if (!customElements.get('dbk-stock-notification')) {
  customElements.define('dbk-stock-notification', class extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      this.button = this.querySelector('[data-stock-notification-button]');
      this.error = this.querySelector('.dbk-stock-notification__error');
      this.dialog = this.querySelector('dialog');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.button?.addEventListener('click', () => this.openForm(), options);
      if (!this.dialog) return;

      this.variants = JSON.parse(this.querySelector('[data-stock-popup-variants]').textContent);
      this.embed = this.querySelector('[data-stock-popup-embed]');
      this.loading = this.querySelector('[data-stock-popup-loading]');
      this.loadError = this.querySelector('[data-stock-popup-load-error]');
      this.heading = this.querySelector('[data-stock-popup-heading]');
      this.introduction = this.querySelector('[data-stock-popup-introduction]');
      this.dialog.querySelector('[data-dbk-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        clearTimeout(this.loadingTimeout);
        this.button.focus({ preventScroll: true });
      }, options);
      let pressedBackdrop = false;
      const outsideDialog = event => {
        const rect = this.dialog.getBoundingClientRect();
        return event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      };
      this.dialog.addEventListener('pointerdown', event => { pressedBackdrop = outsideDialog(event); }, options);
      this.dialog.addEventListener('click', event => {
        if (pressedBackdrop && outsideDialog(event)) this.dialog.close();
        pressedBackdrop = false;
      }, options);
      this.querySelector('[data-stock-popup-retry]').addEventListener('click', () => window.location.reload(), options);
      this.availabilityObserver = new MutationObserver(() => {
        if (this.button.disabled && this.dialog.open) this.dialog.close();
      });
      this.availabilityObserver.observe(this.button, { attributes: true, attributeFilter: ['disabled'] });
      this.embedObserver = new MutationObserver(() => this.checkFormReady());
      this.embedObserver.observe(this.embed, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden'] });
      window.addEventListener('omnisendForms', event => {
        if (event.detail?.form?.id !== this.dataset.formId) return;
        this.checkFormReady();
        // Leave submission and confirmation entirely to the native form.
        // Do not copy contact details from the event or store them in the theme.
      }, options);
      this.checkFormReady();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.availabilityObserver?.disconnect();
      this.embedObserver?.disconnect();
      clearTimeout(this.loadingTimeout);
      if (this.dialog?.open) this.dialog.close();
      this.button = null;
    }

    checkFormReady() {
      if (!this.embed?.querySelector('form, input[type="email"]')) return;
      // Native confirmation visibility also covers variant changes and repeat requests.
      const confirmation = Array.from(this.embed.querySelectorAll('[class$="-success-sections-container"], [class$="-subscribed-sections-container"]'))
        .find(element => element.getClientRects().length > 0);
      this.introduction.hidden = Boolean(confirmation);
      const input = this.embed.querySelector('input[type="email"]');
      if (input && !input.dataset.dbkStyled) {
        input.dataset.dbkStyled = 'true';
        input.setAttribute('aria-label', 'Din mailadresse');
        input.setAttribute('inputmode', 'email');
        input.setAttribute('autocapitalize', 'none');
        input.placeholder = 'dig@eksempel.dk';
        if (!this.embed.querySelector('label[for="' + input.id + '"]')) {
          const label = document.createElement('label');
          label.className = 'dbk-stock-popup__label';
          label.htmlFor = input.id;
          label.textContent = 'Din mailadresse';
          input.before(label);
        }
      }
      this.loading.hidden = true;
      this.loadError.hidden = true;
      clearTimeout(this.loadingTimeout);
    }

    openForm() {
      if (this.button.disabled) return;
      this.error.hidden = true;
      const formId = this.dataset.formId.trim();
      const variantId = this.button.dataset.variantId;
      if (!/^[a-f0-9]{24}$/i.test(formId) || !/^\d+$/.test(variantId)) {
        this.error.hidden = false;
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState(window.history.state, '', url);

      if (this.dataset.formMode !== 'embedded') {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', formId]);
        return;
      }
      const variant = this.variants.find(item => String(item.id) === variantId);
      if (!variant || variant.available) return;
      this.querySelector('[data-stock-popup-variant]').textContent = variant.title === 'Default Title' ? '' : variant.title;
      const image = this.querySelector('[data-stock-popup-image]');
      if (image && variant.image) image.src = variant.image;
      clearTimeout(this.loadingTimeout);
      this.loading.hidden = Boolean(this.embed.querySelector('form, input[type="email"]'));
      this.loadError.hidden = true;
      if (!this.dialog.open) this.dialog.showModal();
      this.heading.focus({ preventScroll: true });
      this.dialog.scrollTop = 0;
      this.loadingTimeout = setTimeout(() => {
        if (!this.loading.hidden && this.dialog.open) {
          this.loading.hidden = true;
          this.loadError.hidden = false;
        }
      }, 12000);
      this.checkFormReady();
    }
  });
}
